import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Form } from "react-bootstrap";
import { Icon } from '@iconify/react';
import { Dropdown } from 'primereact/dropdown';
import { Link, useParams } from 'react-router-dom';
import api from '../../../services/apiIdz';

// Estilos reaproveitados da busca de carros (mesmas classes, mesmo visual)
import '../../Busca/ResultadoBusca/ResultadoBusca.scss';
import 'react-tooltip/dist/react-tooltip.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';

// Components
import NaoEncontrol from "../../Busca/NaoEncontrol";
import LoadingRing from '../../Loading';
import { useSearchMotos } from '../../../context/useSearchMotos';
import { useMediaQuery } from 'react-responsive';

function ResultadoMotos() {

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    const {
        condicao,
        marca,
        modelo
    } = useParams()

    const {
        handleFilterData,
        filterData,
        link,
        loadingData,
        setLoadingData,
        searchData,
        modelos,
        marcas,
        handleParamsData,
        getVeiculos,
        intResumoBusca,
        setIntResumoBusca,
        setFilterData,
        condicoes,
        placeholderPreco
    } = useSearchMotos()

    useEffect(() => {
        handleParamsData({
            condicao: condicao ? condicao : '',
            marca: marca ? marca : '',
            modelo: modelo ? modelo : ''
        })
    }, [])

    useEffect(() => {
        setIntResumoBusca(false)
        setLoadingData(true)

        let query = new URLSearchParams(window.location.search)
        const faixa = query.get("preco-de") + "|" + query.get("preco-ate")

        getVeiculos(condicao, marca, modelo, faixa)

    }, [condicao, marca, modelo])

    const [mostrarFiltros, setMostrarFiltros] = useState(false);

    const handleToggleFiltros = () => {
        setMostrarFiltros(!mostrarFiltros);
    };

    return (
        <>
            <section className='buscaBarra'>
                <Container>
                    <Row className='justify-content-md-center'>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <div className="buscaFiltros">
                                <div className="buscaCampos">
                                    <Row className='justify-content-md-center'>
                                        {mostrarFiltros == true || isMobile == false && (
                                            <Col xs={12} sm={12} md={12} lg={3}>
                                                <Form.Label className='Label'>
                                                    <span>Condição</span>
                                                    <Dropdown emptyMessage="Sem Resultado" value={filterData["condicao"]} onChange={(e) => handleFilterData(e.target.value, "condicao")} options={condicoes} optionLabel="label" placeholder="Selecione" className='Dropdown' />
                                                </Form.Label>
                                            </Col>
                                        )}
                                        <Col xs={12} sm={12} md={12} lg={3}>
                                            <Form.Label className='Label'>
                                                <span>Marca</span>
                                                <Dropdown showClear emptyMessage="Sem Resultado" value={filterData["marca"]} onChange={(e) => {
                                                    handleFilterData(e.target.value, "marca")
                                                }} options={marcas} optionLabel="label" placeholder="Selecione" className='Dropdown' />
                                            </Form.Label>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={3}>
                                            <Form.Label className='Label'>
                                                <span>Modelo</span>
                                                <Dropdown showClear emptyMessage="Sem Resultado" value={filterData["modelo"]} onChange={(e) => handleFilterData(e.target.value, "modelo")} options={modelos} optionLabel="label" placeholder="Selecione" className='Dropdown' />
                                            </Form.Label>
                                        </Col>
                                        {mostrarFiltros == true || isMobile == false && (
                                            <Col xs={12} sm={12} md={12} lg={3}>
                                                <Form.Label className='Label'>
                                                    <span>Faixa de Preço</span>
                                                    <Dropdown emptyMessage="Sem Resultado" value={filterData["faixa"]} onChange={(e) => handleFilterData(e.target.value, "faixa")} options={placeholderPreco} optionLabel="label" placeholder="Selecione" className='Dropdown' />
                                                </Form.Label>
                                            </Col>
                                        )}
                                    </Row>
                                </div>
                                <div className="buscaBtn">
                                    <Link className='btn btn-icon' to={link}><Icon className="icons" icon="mingcute:search-line" /></Link>
                                    <Link onClick={handleToggleFiltros} className='btn btn-icon maisFiltros'>
                                        <Icon icon={mostrarFiltros ? "iconamoon:close-duotone" : "mingcute:filter-line"} />
                                        {mostrarFiltros ? "FECHAR FILTROS" : "FILTRO AVANÇADO"}
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {intResumoBusca ? (
                <section className='naoEncontradosBusca'>
                    <Container>
                        <Row className='justify-content-md-center'>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <h2>ops, não encontramos nenhuma moto como esta!</h2>
                                <h4>Que tal falar com a gente? Podemos te ajudar a encontrar o modelo ideal.</h4>
                            </Col>
                        </Row>
                    </Container>
                </section>
            ) : null}

            {!loadingData && !intResumoBusca ? (
                <>
                    <section className='resumoBusca' id="resumoBuscaMotos">
                        <Container>
                            <Row className='justify-content-md-center'>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <h2>
                                        MOTOS {condicao === 'todos' || condicao === undefined ? 'NOVAS E SEMINOVAS' :
                                            condicao === 'novo' ? 'NOVAS' : 'SEMINOVAS'}
                                    </h2>
                                    <h4>{searchData?.length} veículos encontrados</h4>
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    <section className='resultadoBusca'>
                        <Container>
                            <Row className='justify-content-md-center'>
                                {
                                    searchData?.map((moto, index) => (
                                        <Col key={index} xs={12} sm={12} md={12} lg={4}>
                                            <div className='veiculoBusca'>
                                                <div className='foto' style={{ background: `url(${api.defaults.baseURL}${moto.imagem})  no-repeat center / cover` }}>
                                                </div>
                                                <div className='desc'>
                                                    {moto.status === "Vendido" ? <span className='Vendido'><Icon className="icons" icon="lets-icons:check-fill" /> Vendido</span> : ''}
                                                    <h6>ano {moto.ano_modelo} / {moto.ano_fabricacao}</h6>
                                                    <h3>{moto.modelo}</h3>
                                                    <span>KM</span>
                                                    <h5>{moto.km}</h5>
                                                    <span>COMBUSTÍVEL</span>
                                                    <h5 className='noneBorder'>{moto.combustivel}</h5>
                                                    <div className="acao">
                                                        <div className='valor'>
                                                            <span>VALOR</span>
                                                            <h2>{moto.preco}</h2>
                                                        </div>
                                                        <Link className="btn btn-primary" to={`/detalhe/${moto.seo_url}`}>VER DETALHES</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </Container>
                    </section>
                    <NaoEncontrol />
                </>
            ) : intResumoBusca ? null : <div className='loadingBoxBusca'><LoadingRing /></div>}
        </>
    );
}

export default ResultadoMotos;
